import React from 'react';
import { Content, PageWithHeader } from '@backstage/core-components';
import {
  CatalogFilterLayout,
  EntityKindPicker,
  EntityLifecyclePicker,
  EntityListProvider,
  EntityOwnerPicker,
  EntitySearchBar,
  EntityTypePicker,
} from '@backstage/plugin-catalog-react';
import {
  DomainPicker,
  SystemPicker,
  usePlatformStructureTitles,
} from './PlatformServicePickers';
import { ServiceCardGrid } from './ServiceCardGrid';

/**
 * The services the platform offers, a card each, grouped by domain.
 *
 * Which services these are is decided in the catalog: every `Service` of
 * `spec.type: platform`, see docs/developer_platform_catalog.md.
 *
 * @public
 */
export const PlatformServicesPage = () => {
  const titles = usePlatformStructureTitles();

  return (
    <PageWithHeader
      themeId="service"
      title="Services"
      subtitle="Services the platform offers"
      pageTitleOverride="Services"
    >
      <Content>
        <EntityListProvider>
          <CatalogFilterLayout>
            <CatalogFilterLayout.Filters>
              <EntityKindPicker initialFilter="service" hidden />
              <EntityTypePicker initialFilter="platform" hidden />
              <EntitySearchBar />
              <DomainPicker titles={titles.domains} />
              <SystemPicker titles={titles.systems} />
              {/* Only the teams that own one of the services. */}
              <EntityOwnerPicker mode="owners-only" />
              <EntityLifecyclePicker />
            </CatalogFilterLayout.Filters>
            <CatalogFilterLayout.Content>
              <ServiceCardGrid titles={titles} />
            </CatalogFilterLayout.Content>
          </CatalogFilterLayout>
        </EntityListProvider>
      </Content>
    </PageWithHeader>
  );
};
